import { TFunction } from 'i18next';

import { IWorkingDay } from '@/modules/workingDay/types';

export const getTeamCardData = (
  worker: IWorkingDay.IWorker,
  t: TFunction<'common', undefined>
) => {
  return {
    isDismissed: worker.isDismissed ? t('dismissed') : '-',
    workerName: worker.workerName,
    worker_rate: worker.unitsAchieved,
    incidentReport: worker.incidentReportId,
    // cost: worker?.payment?.toFixed(2),
  };
};

export const getTeamHeaderCardData = (
  worker: IWorkingDay.IJobInstanceSupplier,
  t: TFunction<'common', undefined>,
  productivityMeasurementUnit: string
) => {
  return {
    team_leader: worker.supplierName,
    attendance: `${worker.workerAttendance} ${t('individual')}`,
    worker_rate: `${worker.unitsAchieved} ${t('from')} ${
      worker.averageTargetPerDay
    } ${productivityMeasurementUnit || ''}`,
    incident: worker.incidentReports || '-',
    // cost: worker?.payment?.toFixed(2),
  };
};
